module.exports = __webpack_public_path__ + "img/5-Frontline-Populated-Details-Page.de7257ff.png";